import type { RouteRecordRaw } from 'vue-router';
import DashboardsPage from './pages/DashboardPage/DashboardPage.vue';

export const main: RouteRecordRaw[] = [
  {
    name: 'dashboard',
    path: 'dashboard',
    component: DashboardsPage,
    meta: {
      requiresAuth: true,
      headerTitle: 'DASHBOARD',
    },
  },
];

export const base: RouteRecordRaw[] = [];
